import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { fetchPhotos, Photo, uploadSingleImage, uploadMultipleImages } from '../thunks/imageThunks';

interface PhotoState {
  photos: Photo[];
  isSlideshowOpen: boolean;
  isLandscape: boolean;
  status: 'idle' | 'loading' | 'succeeded' | 'failed';
  errorMessage: string | null;
}

const initialState: PhotoState = {
  photos: [],
  isSlideshowOpen: false,
  isLandscape: false,
  status: 'idle',
  errorMessage: null,
};

const imageSlice = createSlice({
  name: 'photos',
  initialState,
  reducers: {
    openSlideshow: (state) => {
      state.isSlideshowOpen = true;
    },
    closeSlideshow: (state) => {
      state.isSlideshowOpen = false;
    },
    toggleOrientation: (state) => {
      state.isLandscape = !state.isLandscape;
    },
    resetPhotos: () => initialState,
    resetStatus: (state) => {
      state.status = 'idle';
      state.errorMessage = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch Photos
      .addCase(fetchPhotos.pending, (state) => {
        state.status = 'loading';
        state.photos = [];
        state.errorMessage = null;
      })
      .addCase(fetchPhotos.fulfilled, (state, action: PayloadAction<Photo[]>) => {
        state.status = 'succeeded';
        state.photos = action.payload;
      })
      .addCase(fetchPhotos.rejected, (state, action) => {
        state.status = 'failed';
        state.errorMessage = action.payload as string;
      })

      // Upload Single Image
      .addCase(uploadSingleImage.pending, (state) => {
        state.status = 'loading';
        state.errorMessage = null;
      })
      .addCase(uploadSingleImage.rejected, (state, action) => {
        state.status = 'failed';
        state.errorMessage = action.payload as string;
      })

      // Upload Multiple Images
      .addCase(uploadMultipleImages.pending, (state) => {
        state.status = 'loading';
        state.errorMessage = null;
      })
      .addCase(uploadMultipleImages.rejected, (state, action) => {
        state.status = 'failed';
        state.errorMessage = action.payload as string;
      });
  },
});

export const {
  openSlideshow,
  closeSlideshow,
  toggleOrientation,
  resetPhotos,
  resetStatus,
} = imageSlice.actions;

export default imageSlice.reducer;
